import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { Vehicle } from 'types';
import { providesList } from './utils';

export const vehicleEndpoints = (builder: EndpointBuilder<any, any, any>) => ({
  getAllVehicles: builder.query<Vehicle[], void>({
    query: () => `/vehicle/`,
    providesTags: results => providesList(results, 'Vehicle'),
  }),
});
